import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resetAction, hideTopNav } from "../../../App/state/actions";
import { SHOW_PURCHASE_ACKNOWLEDGEMENT } from "../state/actions";
import { resetPlayerAttributes } from "../helpers/dynatraceHelpers";
import { useReducers } from "../../../shared/hooks/useReducer";
import constants from "../../../shared/constants";

const { REDUCER_TYPE } = constants;

const usePlayerUnmount = (cancelTokenSource, userInactivityTimer, pcPinTimer) => {
  const dispatch = useDispatch();
  const { featureToggles } = useReducers(REDUCER_TYPE.APP);
  const { isDynatraceTrackingEnabled } = featureToggles;
  useEffect(() => {
    const unmountTokenSource = cancelTokenSource.current;
    return () => {
      unmountTokenSource.cancel(); // silent cancellation of middleware requests
    };
  }, [cancelTokenSource]);

  useEffect(() => {
    return () => {
      dispatch(resetAction(SHOW_PURCHASE_ACKNOWLEDGEMENT, "content"));
      resetPlayerAttributes(isDynatraceTrackingEnabled);
    };
  }, [dispatch, isDynatraceTrackingEnabled]);

  useEffect(() => {
    dispatch(hideTopNav(true));
    const userInactivityTimerCurrent = userInactivityTimer.current;
    const pcPinTimerCurrent = pcPinTimer.current;
    return () => {
      dispatch(hideTopNav(false));
      if (userInactivityTimerCurrent) {
        clearTimeout(userInactivityTimerCurrent);
      }
      if (pcPinTimerCurrent) {
        clearInterval(pcPinTimerCurrent);
      }
    };
  }, [dispatch, userInactivityTimer, pcPinTimer]);
};

export default usePlayerUnmount;
